export const WIDGET_ROOT_ID = 'enable-widget';
